export default {
  getTranslation: (state) => (id) =>
    state.translations.find((translation) => translation.id === id),
};
